"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var date_1 = require("../../../../utils/date");
var ProgressBar_styled_1 = require("./ProgressBar.styled");
var ProgressBar = function (_a) {
    var start = _a.start, end = _a.end;
    var progress = (0, date_1.daysInRange)(start, Date.now());
    var total = (0, date_1.daysInRange)(start, end);
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var progressLabelId = 'daysRemaining';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ProgressBar_styled_1.ProgressLabel, { "data-testid": "billing-progress-label", id: progressLabelId },
            react_1.default.createElement(Copy, { copyKey: "daysRemaining", values: { count: total - progress } })),
        react_1.default.createElement(ProgressBar_styled_1.ProgressBackground, { "data-testid": "billing-progress-bar", role: "progressbar", "aria-labelledby": progressLabelId, "aria-valuenow": progress, "aria-valuemax": total },
            react_1.default.createElement(ProgressBar_styled_1.ProgressForeground, { width: (progress / total) * 100 }))));
};
exports.ProgressBar = ProgressBar;
